<!-- @format -->
<template>
	<div v-if="pcProps.isRequired === '0' || disabled" class="pc-form-rich-text ql-container ql-snow">
		<div class="ql-editor">
			<div v-html="value" />
		</div>
	</div>
	<pc-editor v-else :value="value" :min-height="200" style="width: 100%" @chang-content="changContent" />
</template>

<script setup lang="ts">
	import { type WidgetConfigType } from '../../types';
	import { PcEditor } from '@/components';

	interface Props {
		modelValue: string;
		pcProps: WidgetConfigType;
		disabled?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
	});

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});

	const changContent = (val) => {
		value.value = val;
	};
</script>

<style scoped lang="scss">
	.pc-form-rich-text {
		height: 100%;
		width: 100%;
		border: none;
	}
</style>
